import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Trabaja bajo presión (shift, deadlines, calls, clientes)', 'Siempre trae mil cosas en la cabeza', 'Ya intentó “meditar” y lo dejó porque no tiene tiempo', 'Se da cuenta que últimamente contesta más seco, se irrita más fácil, y le cuesta enfocarse…'];
  return <Section className="bg-[#0A0A0A]" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="mb-12 text-center md:text-left" data-id="element-157">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-158">
            Esto no es para “relajarte”.
          </h2>
          <p className="text-xl md:text-2xl text-[#EF4444] font-bold" data-id="element-159">
            Es para que puedas funcionar cuando estás al límite.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-160">
          <div className="bg-[#111111] border border-red-900/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-161">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[60px] rounded-full" data-id="element-162" />

            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-163">
              <span className="w-2 h-8 bg-[#EF4444] rounded-full" data-id="element-164" />
              Si tú eres el que:
            </h3>

            <ul className="space-y-4" data-id="element-165">
              {painPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-166">
                  <XCircle className="w-6 h-6 text-[#EF4444] shrink-0 mt-0.5" data-id="element-167" />
                  <span data-id="element-168">{point}</span>
                </li>)}
            </ul>
          </div>

          <div className="space-y-8 text-lg text-gray-300" data-id="element-169">
            <div data-id="element-170">
              <p className="mb-4" data-id="element-171">Entonces probablemente ya viste el patrón:</p>
              <p className="font-medium text-white" data-id="element-172">Empieza el día.</p>
              <p data-id="element-173">Y sin darte cuenta, entras en modo alerta.</p>
            </div>

            <div className="pl-6 border-l-2 border-gray-800" data-id="element-174">
              <p className="mb-4" data-id="element-175">No es que seas débil.</p>
              <p className="text-white font-bold" data-id="element-176">
                Es que estás operando con el sistema equivocado:
              </p>
              <p className="mt-2" data-id="element-177">
                Quieres claridad mental… pero tu cuerpo está en alarma.
              </p>
              <p data-id="element-178">Quieres tomar buenas decisiones… pero estás reaccionando.</p>
            </div>

            <div data-id="element-179">
              <p className="text-[#EF4444] font-bold mb-2" data-id="element-180">Y eso cuesta.</p>
              <p data-id="element-181">Cuesta en performance, en reputación, en energía.</p>
              <p className="mt-2 text-gray-400 italic" data-id="element-182">
                Cuesta en tu casa, porque llegas “presente” físicamente… pero
                mentalmente sigues en el job.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}